import script from "./FormSendEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSendEmail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__